import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import api from '../../api/axios';
import AuthContext from '../../context/AuthContext';

import CohortChart from './CohortChart';
import TimeHeatmap from './TimeHeatmap';
import OptionAttachRateCard from './OptionAttachRateCard';

const ReportGroup = ({ startDate, endDate }) => {
    const { user } = useContext(AuthContext);
    const [cohortData, setCohortData] = useState(null);
    const [heatmapData, setHeatmapData] = useState(null);
    const [optionsRateData, setOptionsRateData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!startDate || !endDate || !user) {
            return;
        }

        const fetchAllReportData = async () => {
            setLoading(true);
            setError('');
            try {
                const cohortParams = { endDate };
                const otherParams = { startDate, endDate };
                
                const [cohortRes, heatmapRes, optionsRateRes] = await Promise.all([
                    api.get('/reports/cohort', { params: cohortParams }),
                    api.get('/reports/heatmap', { params: otherParams }),
                    api.get('/reports/options-rate', { params: otherParams })
                ]);

                setCohortData(cohortRes.data.data);
                setHeatmapData(heatmapRes.data.data);
                setOptionsRateData(optionsRateRes.data.data);

            } catch (err) {
                console.error("Failed to fetch report data", err);
                const message = err.response?.data?.message || '리포트 데이터를 불러오는 중 오류가 발생했습니다.';
                setError(message);
            } finally {
                setLoading(false);
            }
        };

        fetchAllReportData();
    }, [startDate, endDate, user]);

    if (error) {
        return <Alert variant="danger">{error}</Alert>;
    }

    return (
        <div>
            <Row className="mb-4">
                <Col>
                    <h4>시간대/요일별 분석</h4>
                    <TimeHeatmap data={heatmapData} isLoading={loading} />
                </Col>
            </Row>
            <Row className="mb-4">
                <Col>
                    <h4>옵션 채택률</h4>
                    <OptionAttachRateCard data={optionsRateData} isLoading={loading} />
                </Col>
            </Row>
            <Row className="mb-4">
                <Col>
                    <h4>월별 재방문 현황 (최근 12개월)</h4>
                    <CohortChart data={cohortData} isLoading={loading} />
                </Col>
            </Row>
        </div>
    );
};

export default ReportGroup;
